import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ConfirmDeactivateModal.css";

const ConfirmDeactivateModal = ({ show, onClose, onConfirm, isActive, suffixMsg = `Online Store`}) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="custom-modal"
      backdrop="static"
    >
      <Modal.Body className="text-center">
        <div className="warning-icon mb-3">
          <img
            src="https://cdn-icons-png.flaticon.com/512/564/564619.png"
            alt="warning"
            width={40}
          />
        </div>
        <p className="modal-message">
          {t("admin.orders.confirmToggle", { action: isActive ? t("common.deactivate").toLowerCase() : t("common.activate").toLowerCase(), item: suffixMsg })}
        </p>
        <div className="d-flex justify-content-end gap-3 mt-4">
          <Button variant="light" onClick={onClose} className="btn-no mr-4">
            {t("common.no")}
          </Button>
          <Button variant="primary" onClick={onConfirm} className="btn-yes">
            {t("common.yes")}
          </Button>
        </div>
      </Modal.Body>
      <button className="close-btn" onClick={onClose}>
        &times;
      </button>
    </Modal>
  );
};

export default ConfirmDeactivateModal;
